import { RespondConferenceWaitingRoom } from 'domain/usecases/conferenceWaitingRoom/remote';
import {
  NotFound,
  BadRequestError,
  Forbidden,
  UnexpectedError,
  BadGateway,
} from 'domain/errors';
import { HttpClient, HttpStatusCode } from 'data/protocols/http';
import 'infra/global/variables';

export class RemoteRespondConferenceWaitingRoom
  implements RespondConferenceWaitingRoom
{
  private readonly url: string;

  private readonly httpClient: HttpClient<RespondConferenceWaitingRoom.Model>;

  constructor(
    url: string,
    httClient: HttpClient<RespondConferenceWaitingRoom.Model>,
  ) {
    this.url = url;
    this.httpClient = httClient;
  }

  respond = async (
    params: RespondConferenceWaitingRoom.Params,
  ): Promise<RespondConferenceWaitingRoom.Model> => {
    const httpResponse = await this.httpClient.request({
      url: this.url.replace('{conferenceShort}', params.conferenceShort),
      body: params.body,
      method: 'post',
    });
    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
      case HttpStatusCode.created:
      case HttpStatusCode.accepted:
      case HttpStatusCode.noContent:
        return httpResponse.body;
      case HttpStatusCode.badRequest:
        throw new BadRequestError();
      case HttpStatusCode.notFound:
        throw new NotFound();
      case HttpStatusCode.unauthorized:
        throw new Forbidden();
      case HttpStatusCode.badGateway:
        throw new BadGateway();
      default:
        throw new UnexpectedError();
    }
  };
}
